export const SECTION = {
  MAIN_RESEREVATIONS: "MAIN_RESEREVATIONS",
  MAIN_INVENTORIES: "MAIN_INVENTORIES",
  MAIN_INTEGRATIONS: "MAIN_INTEGRATIONS",
  MAIN_REPORTS: "MAIN_REPORTS",
  MAIN_COMMUNICATIONS: "MAIN_COMMUNICATIONS",
  MAIN_SETTINGS: "MAIN_SETTINGS",
  MAIN_LOYALTY: "MAIN_LOYALTY",
  MAIN_USERS: "MAIN_USERS",
  MAIN_INTERNAL_INTEGRATIONS: "MAIN_INTERNAL_INTEGRATIONS",
  MAIN_OLD_CRM: "MAIN_OLD_CRM",
  MAIN_CRM: "MAIN_CRM",
  MAIN_UTILITIES: "MAIN_UTILITIES",
  MAIN_ADMIN_CONTROL_PANEL: "MAIN_ADMIN_CONTROL_PANEL",
  MAIN_ONLINE_STORE: "MAIN_ONLINE_STORE",
  MAIN_ORCHESTRATOR: "MAIN_ORCHESTRATOR",
  RESERVATIONS_LIST: "RESERVATIONS_LIST",
  RESERVATIONS_LIST_EXTENDED: "RESERVATIONS_LIST_EXTENDED",
  INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
  EXTRAS: "EXTRAS",
  PROMOTIONS: "PROMOTIONS",
  INVENTORY_CONFIGURATION: "INVENTORY_CONFIGURATION",
  ACCOMMODATIONS: "ACCOMMODATIONS",
  OCCUPATIONS: "OCCUPATIONS",
  CONDITIONS: "CONDITIONS",
  MEAL_PLANS: "MEAL_PLANS",
  INVENTORY_LINES: "INVENTORY_LINES",
  INVENTORY_LINES_EXCEL: "INVENTORY_LINES_EXCEL",
  DYNAMIC_PRICE_RULES: "DYNAMIC_PRICE_RULES",
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS",
  CUSTOM_MARKUPS: "CUSTOM_MARKUPS",
  RESERVATION_STATS: "RESERVATION_STATS",
  STAYS_PER_DAY: "STAYS_PER_DAY",
  EXTENDED_RESERVATION_STATS: "EXTENDED_RESERVATION_STATS",
  QUERY_STATS: "QUERY_STATS",
  BILLING_REPORT: "BILLING_REPORT",
  WEB_MESSAGES: "WEB_MESSAGES",
  ALERT_SETTINGS: "ALERT_SETTINGS",
  CONFIRMATION_EMAIL_SETTINGS: "CONFIRMATION_EMAIL_SETTINGS",
  EMAIL_LISTING: "EMAIL_LISTING",
  PRE_STAY_EMAIL_SETTINGS: "PRE_STAY_EMAIL_SETTINGS",
  POST_STAY_EMAIL_SETTINGS: "POST_STAY_EMAIL_SETTINGS",
  POST_STAY_POLL_SETTINGS: "POST_STAY_POLL_SETTINGS",
  POST_STAY_POLL_RESULTS: "POST_STAY_POLL_RESULTS",
  QUESTIONNAIRES: "QUESTIONNAIRES",
  CUSTOM_EMAIL: "CUSTOM_EMAIL",
  PROPERTY_INFO: "PROPERTY_INFO",
  BEHAVIOR_SETTINGS: "BEHAVIOR_SETTINGS",
  LANGUAGE_SETTINGS: "LANGUAGE_SETTINGS",
  CUSTOMER_INFO_SETTINGS: "CUSTOMER_INFO_SETTINGS",
  CURRENCY_SETTINGS: "CURRENCY_SETTINGS",
  TAX_SETTINGS: "TAX_SETTINGS",
  CREDIT_CARD_SETTINGS: "CREDIT_CARD_SETTINGS",
  PAYMENT_METHODS: "PAYMENT_METHODS",
  OCCUPANT_SETTINGS: "OCCUPANT_SETTINGS",
  INVENTORY_SETTINGS: "INVENTORY_SETTINGS",
  APPEARANCE_SETTINGS: "APPEARANCE_SETTINGS",
  DISPLAY: "DISPLAY",
  CHANGE_OWN_PASSWORD: "CHANGE_OWN_PASSWORD",
  LEGAL_INFO: "LEGAL_INFO",
  RESERVATION_MODIFICATION_POLICY: "RESERVATION_MODIFICATION_POLICY",
  FILTERS: "FILTERS",
  CANCELLATION_POLICY: "CANCELLATION_POLICY",
  PROPERTY_USERS: "PROPERTY_USERS",
  USER_ACCESS_TO_PROPERTY: "USER_ACCESS_TO_PROPERTY",
  CREATE_PROPERTY: "CREATE_PROPERTY",
  CREATE_USER: "CREATE_USER",
  CHANGE_USER_PASSWORD: "CHANGE_USER_PASSWORD",
  REPLICATE_PROPERTY: "REPLICATE_PROPERTY",
  EXECUTE_BATCH_SQL_QUERY: "EXECUTE_BATCH_SQL_QUERY",
  GLOBAL_EMAIL_LIST: "GLOBAL_EMAIL_LIST",
  SITEMINDER_SETTINGS: "SITEMINDER_SETTINGS",
  TRIPADVISOR_RE_SETTINGS: "TRIPADVISOR_RE_SETTINGS",
  RATEGAIN_SETTINGS: "RATEGAIN_SETTINGS",
  PARITYRATE_SETTINGS: "PARITYRATE_SETTINGS",
  INTEGRATION_PARAMETERS: "INTEGRATION_PARAMETERS",
  PROPERTY_CONFIGURATION: "PROPERTY_CONFIGURATION",
  CHANNEL_LOGS: "CHANNEL_LOGS",
  RESEND_RESERVATION_TO_CHANNEL: "RESEND_RESERVATION_TO_CHANNEL",
  CRM_CLIENT: "CRM_CLIENT",
  CRM_PROPERTY: "CRM_PROPERTY",
  CRM_SERVICE: "CRM_SERVICE",
  CRM_CONTRACT: "CRM_CONTRACT",
  CRM_PARTNER: "CRM_PARTNER",
  CRM_BILLING_REPORT: "CRM_BILLING_REPORT",
  PROPERTY_PARAMETERS: "PROPERTY_PARAMETERS",
  CHECK_INVENTORY_INTEGRITY: "CHECK_INVENTORY_INTEGRITY",
  PROPERTY_CHANNEL_MANAGERS: "PROPERTY_CHANNEL_MANAGERS",
  USER_PROPERTIES_MANAGER: "USER_PROPERTIES_MANAGER",
  GENERATE_BILLING_REPORT: "GENERATE_BILLING_REPORT",
  CHAIN_CONFIGURER: "CHAIN_CONFIGURER",
  QUERY_EXECUTOR: "QUERY_EXECUTOR",
  GOOGLE_FEED: "GOOGLE_FEED",
  ARI_SNAPSHOT: "ARI_SNAPSHOT",
  PACKAGES: "PACKAGES",
  BUNDLES: "BUNDLES",
  BUNDLES_CREATE: "BUNDLES_CREATE",
  BUNDLES_EDIT: "BUNDLES_EDIT",
  QUOTATION: "QUOTATION",
  PRICE_FEED: "PRICE_FEED",
  CHANGE_USER_GROUP: "CHANGE_USER_GROUP",
  CONNECTIONS_WIT_CHANNEL: "CONNECTIONS_WIT_CHANNEL",
  USERS_JAVA_PROPERTY_TO_EXCEL: "USERS_JAVA_PROPERTY_TO_EXCEL",
  GOOGLE_HOTEL_FINDER: "GOOGLE_HOTEL_FINDER",
  COMPARE_DATABASE: "COMPARE_DATABASE",
  SYSTEM_CONTROL_PANEL: "SYSTEM_CONTROL_PANEL",
  BILLING_EVOLUTION: "BILLING_EVOLUTION",
  LOYALTY_CUSTOMERS: "LOYALTY_CUSTOMERS",
  LOYALTY_ORGANIZATIONS: "LOYALTY_ORGANIZATIONS",
  LOYALTY_DERIVED_TIERS: "LOYALTY_DERIVED_TIERS",
  LOYALTY_CONSTANT_TIERS: "LOYALTY_CONSTANT_TIERS",
  LOYALTY_CUSTOMER_TRANSACTION_REPORT: "LOYALTY_CUSTOMER_TRANSACTION_REPORT",
  LOYALTY_PREFERENCES: "LOYALTY_PREFERENCES",
  LOYALTY_BRAND_MANAGER: "LOYALTY_BRAND_MANAGER",
  B2B_COMMERCIAL_CONDITIONS: "B2B_COMMERCIAL_CONDITIONS",
  TAX_CONFIGURATION: "TAX_CONFIGURATION",
  LOYALTY_HISTORICAL: "LOYALTY_HISTORICAL",
  LOYALTY_LINKS_GENERATOR: "LOYALTY_LINKS_GENERATOR",
  UPGRADE_TIER: "UPGRADE_TIER",
  USER_MANAGER: "USER_MANAGER",
  DASHBOARD: "DASHBOARD",
  TAXES: "TAXES",
  PROPERTY_CALENDAR_REGEN: "PROPERTY_CALENDAR_REGEN",
  MIGRATE_RESERVATION: "MIGRATE_RESERVATION",
  GTM_MANAGER: "GTM_MANAGER",
  FEES_MANAGER: "FEES_MANAGER",
  TAXES_MANAGER: "TAXES_MANAGER",
  TAGS_MANAGER: "TAGS_MANAGER",
  MAPS_MANAGER: "MAPS_MANAGER",
  EDIT_USER_BATCH: "EDIT_USER_BATCH",
  CREATE_USER_BATCH: "CREATE_USER_BATCH",
  WAITING_LIST_REPORT: "WAITING_LIST_REPORT",
  EMAIL_BLACKLIST: "EMAIL_BLACKLIST",
  ENGINE_MULTI_CONFIG: "ENGINE_MULTI_CONFIG",
  SELLING_CONFIGURATION: "SELLING_CONFIGURATION",
  UPGRADE_MANAGER: "UPGRADE_MANAGER",
  AUTOMATIC_CHARGES: "AUTOMATIC_CHARGES",
  ONLINE_STORE_ORDERS: "ONLINE_STORE_ORDERS",
  ONLINE_STORE_BOOKABLE_PRODUCTS: "ONLINE_STORE_BOOKABLE_PRODUCTS",
  ONLINE_STORE_UNITARY_PRODUCTS: "ONLINE_STORE_UNITARY_PRODUCTS",
  FUNCTIONALITY_REPORT: "FUNCTIONALITY_REPORT",
  ORCHESTRATOR_GLOBAL_ACTIONS: "ORCHESTRATOR_GLOBAL_ACTIONS",
  ORCHESTRATOR_SEGMENTS: "ORCHESTRATOR_SEGMENTS",
  ORCHESTRATOR_SCENARIOS: "ORCHESTRATOR_SCENARIOS",
  ORCHESTRATOR_EXPERIMENTS: "ORCHESTRATOR_EXPERIMENTS",
  ORCHESTRATOR_BOOKING_FORM: "ORCHESTRATOR_BOOKING_FORM",
  INSURANCES: "INSURANCES",
  ENGINE_FILTERS: "ENGINE_FILTERS",
  CAMPING_MAP: "CAMPING_MAP",
  CAMPING_MAPPING_MANAGER: "CAMPING_MAPPING_MANAGER",
  MARKETING_MANAGER: "MARKETING_MANAGER",
};

export const SVGSECTION = {
  reservationListing: "reservationListing",
  reservationExpanded: "reservationExpanded",
  reservationInsert: "reservationInsert",
  reservationCallCenter: "reservationCallCenter",
  inventoryManagement: "inventoryManagement",
  inventoryExtras: "inventoryExtras",
  inventoryDefine: "inventoryDefine",
  inventoryPromotions: "inventoryPromotions",
  inventoryDynamicPricing: "inventoryDynamicPricing",
  integrationsGoogleAnalytics: "integrationsGoogleAnalytics",
  integrationsMarkupManager: "integrationsMarkupManager",
  integrationsLanguages: "integrationsLanguages",
  integrationsCurrencies: "integrationsCurrencies",
  integrationsOccupancyTypes: "integrationsOccupancyTypes",
  integrationsCampingMap: "integrationsCampingMap",
  reportsBookingStatistics: "reportsBookingStatistics",
  reportsBookingsByConcept: "reportsBookingsByConcept",
  reportsBookingsByState: "reportsBookingsByState",
  reportsStaysPerDay: "reportsStaysPerDay",
  reportsListOfQueries: "reportsListOfQueries",
  reportsBillingReport: "reportsBillingReport",
  reportsPriceFeed: "reportsPriceFeed",
  commWebMessages: "commWebMessages",
  commAlerts: "commAlerts",
  commEmailListing: "commEmailListing",
  commEmailConfirmation: "commEmailConfirmation",
  commEmailPreStay: "commEmailPreStay",
  commEmailPostStay: "commEmailPostStay",
  commPostStaySurvey: "commPostStaySurvey",
  commSurveyResults: "commSurveyResults",
  commForms: "commForms",
  commCustomEmails: "commCustomEmails",
  settingsPropertyInfo: "settingsPropertyInfo",
  settingsBehavior: "settingsBehavior",
  settingsParameterization: "settingsParameterization",
  settingsAppearance: "settingsAppearance",
  settingsDisplay: "settingsDisplay",
  settingsChangePassword: "settingsChangePassword",
  settingsLegalInfo: "settingsLegalInfo",
  settingsModificationPolicies: "settingsModificationPolicies",
  settingsFilters: "settingsFilters",
  settingsCancellationPolicies: "settingsCancellationPolicies",
  loyaltyCustomers: "loyaltyCustomers",
  derivedLoyaltyTiers: "derivedLoyaltyTiers",
  constantLoyaltyTiers: "constantLoyaltyTiers",
  customerTransactionReport: "customerTransactionReport",
  loyaltyOrganizations: "loyaltyOrganizations",
  loyaltyPreferences: "loyaltyPreferences",
  brandManager: "brandManager",
  //internal-menu
  usersList: "usersList",
  usersCreate: "usersCreate",
  usersCreateCentral: "usersCreateCentral",
  usersAssignPermissions: "usersAssignPermissions",
  usersChangeCentralPassword: "usersChangeCentralPassword",
  usersChangeUserGroup: "usersChangeUserGroup",
  usersReplicatePropertyInDevel: "usersReplicatePropertyInDevel",
  usersConnectionsWitchannel: "usersConnectionsWitchannel",
  usersJavaPropertiesToExcel: "usersJavaPropertiesToExcel",
  usersGoogleHotelFinder: "usersGoogleHotelFinder",
  usersQueryAllProperties: "usersQueryAllProperties",
  usersEmailListings: "usersEmailListings",
  integrationsSiteminder: "integrationsSiteminder",
  integrationsTripAdvisorRE: "integrationsTripAdvisorRE",
  integrationsRategain: "integrationsRategain",
  integrationsParityRate: "integrationsParityRate",
  integrationsGeneralParameters: "integrationsGeneralParameters",
  integrationsConfigurationManager: "integrationsConfigurationManager",
  integrationsChannelLogs: "integrationsChannelLogs",
  integrationsForwardingReservations: "integrationsForwardingReservations",
  integrationsGoogleFeed: "integrationsGoogleFeed",
  integrationsQueryExecutor: "integrationsQueryExecutor",
  integrationsChannelManager: "integrationsChannelManager",
  integrationsChain: "integrationsChain",
  integrationsDiscrepancies: "integrationsDiscrepancies",
  integrationsTaxConfiguration: "integrationsTaxConfiguration",
  crmContracts: "crmContracts",
  crmContractsInForce: "crmContractsInForce",
  crmEditContract: "crmEditContract",
  crmBetaClients: "crmBetaClients",
  crmBetaProperties: "crmBetaProperties",
  crmBetaServices: "crmBetaServices",
  crmBetaContracts: "crmBetaContracts",
  crmBetaPartners: "crmBetaPartners",
  crmBetaGenerate: "crmBetaGenerate",
  crmBetaExtendedBillingReport: "crmBetaExtendedBillingReport",
  utilitiesParameterization: "utilitiesParameterization",
  utilitiesCheckInventoryIntegrity: "utilitiesCheckInventoryIntegrity",
  utilitiesCompareDatabase: "utilitiesCompareDatabase",
  adminControlPanelStatistics: "adminControlPanelStatistics",
  adminControlPanelReservationEvolution: "adminControlPanelReservationEvolution",
  tagsManagement: "tagsManagement",
  mapsManagement: "mapsManagement",
  customerInfoSettings: "customerInfoSettings",
  feesManager: "feesManager",
  taxesManager: "taxesManager",
  paymentMethods: "paymentMethods",
  onlineStoreOrders: "onlineStoreOrders",
  onlineStoreBookableProducts: "onlineStoreBookableProducts",
  onlineStoreUnitaryProducts: "onlineStoreUnitaryProducts",
  onlineStorePreview: "onlineStorePreview",
  insurances: "insurances",
  whatsAppConcierge: "whatsAppConcierge",
};

export const TIER_TYPE_EXTERNAL: { [index: number]: string } = {
  0: "invalid",
  1: "push",
  2: "calc",
};
